export interface IColorHues {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
}

const colors = {
  contrastThreshold: 7,

  // Singleton colors
  white: '#ffffff',
  black: '#000000',
  lightText: '#ffffff',
  darkText: '#1a1a1a',

  // Primary colors
  purple: {
    50: '#fbebff',
    100: '#efd7f4',
    200: '#dcb2e6',
    300: '#c890d5',
    400: '#b66bc7',
    500: '#9e47b2',
    600: '#8b2da0',
    700: '#791e8e',
    800: '#5e0f70',
    900: '#3f064b',
  },
  blue: {
    50: '#ebefff',
    100: '#d5dff6',
    200: '#afc3ee',
    300: '#8199d9',
    400: '#3956a7',
    450: '#162d88',
    500: '#162d6d',
    600: '#19274c',
    700: '#182139',
    800: '#141a29',
    900: '#0d111b',
  },
  cyan: {
    50: '#ebfffd',
    100: '#d5f6f4',
    200: '#acece6',
    300: '#83e2d9',
    400: '#23c7b9',
    500: '#09b5a6',
    600: '#009f92',
    700: '#008579',
    800: '#00665d',
    900: '#004c46',
  },
  teal: {
    50: '#ebfaff',
    100: '#d5edf6',
    200: '#afdae9',
    300: '#8ac6db',
    400: '#63b2cf',
    500: '#429dbd',
    600: '#207fa1',
    700: '#146f8f',
    800: '#095b78',
    900: '#02374a',
  },
  green: {
    50: '#eff5f2',
    100: '#d7eae1',
    200: '#acdcc6',
    300: '#86caaa',
    400: '#35a76e',
    500: '#017a47',
    600: '#04623a',
    700: '#044d2e',
    800: '#103823',
    900: '#0c2c1b',
  },
  yellow: {
    50: '#fffae5',
    100: '#fff5cc',
    200: '#ffea9b',
    300: '#ffe275',
    400: '#ffdb47',
    500: '#ffcb05',
    600: '#d2ab13',
    700: '#aebf13',
    800: '#7d6712',
    900: '#4c3f0b',
  },
  orange: {
    50: '#fff3e5',
    100: '#ffe7cc',
    200: '#fed19a',
    300: '#febf71',
    400: '#faa438',
    500: '#f69904',
    600: '#ce7c09',
    700: '#935d10',
    800: '#643f0c',
    900: '#402808',
  },
  red: {
    50: '#ffebeb',
    100: '#f5d9d6',
    200: '#ebb4ad',
    300: '#e08c81',
    400: '#d7695b',
    500: '#be322e',
    600: '#9b1b17',
    700: '#760d0a',
    800: '#620704',
    900: '#4f0401',
  },
  coolGray: {
    50: '#f9fafb',
    100: 'transparent',
    200: 'transparent',
    300: 'transparent',
    400: 'transparent',
    500: 'transparent',
    600: 'transparent',
    700: 'transparent',
    800: 'transparent',
    900: 'transparent',
  },
  gray: {
    50: '#f7f7f7',
    100: '#ebebeb',
    200: '#e2e2e2',
    300: '#cbcbcb',
    400: '#adadad',
    500: '#737373',
    600: '#5e5e5e',
    700: '#474747',
    800: '#2e2e2e',
    900: '#1a1a1a',
  },

  // Derived colors
  danger: {} as IColorHues,
  error: {} as IColorHues,
  success: {} as IColorHues,
  warning: {} as IColorHues,
  muted: {} as IColorHues,
  primary: {} as IColorHues,
  info: {} as IColorHues,
  secondary: {} as IColorHues,
  light: {} as IColorHues,
  tertiary: {} as IColorHues,
};

colors.danger = colors.red;
colors.error = colors.red;
colors.success = colors.green;
colors.warning = colors.orange;
colors.muted = colors.gray;
colors.primary = colors.yellow;
colors.secondary = colors.blue;
colors.tertiary = colors.gray;
colors.info = colors.blue;
colors.light = colors.gray;

export default colors;
